// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import api from '../../../services/api';

/**
 * Runs one of the three bookshop reports for the signed-in shop over a date
 * range and returns it as a base64 CSV.
 *
 * POST rather than a download link on purpose: the credentials travel in the
 * body, so the token never ends up in a URL, browser history or the server's
 * access log. The page turns the base64 into a Blob and saves it, which the
 * browser treats exactly like any other download.
 */
export const getBookshopReportService = async (data) => {
  return api('/Sellitback.svc/GetBookshopReport', data, 'POST');
};
